var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"site",class:{ 'prefers-reduced-motion': _vm.prefersReducedMotion }},[_c('main',[_c('router-view',{class:{ 'prefers-reduced-motion': _vm.prefersReducedMotion }})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }